import React, { useState } from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import './styles.css';

const Fade = require('react-reveal/Fade');
const Zoom = require('react-reveal/Zoom');

interface HeaderProps{
    setPortuguese?: React.MouseEventHandler<HTMLElement>;
    setEnglish?: React.MouseEventHandler<HTMLElement>;
}

const Header: React.FC<HeaderProps> = ({ setPortuguese, setEnglish }) =>{
    const [mouseOver, setMouseOver] = useState(false)
    const [menuIsOpen, setMenuIsOpen] = useState(false)
    const [mouseOverLanguage, setMouseOverLanguage] = useState(false)
    const [aboutMeOptions, setAboutMeOptions] = useState(false)
    const [languageOptions, setLanguageOptions] = useState(false)

    function handleMouseOver(){
        setMouseOver( !mouseOver )
    }

    function handleMouseOverLanguages(){
        setMouseOverLanguage( !mouseOverLanguage )
    }

    function handleMenuIsOpen(){
        setMenuIsOpen( !menuIsOpen )
    }

    function handleAboutMeOptions(){
        setAboutMeOptions( !aboutMeOptions )
    }

    function handleLanguageOptions(){
        setLanguageOptions( !languageOptions )
    }

    function teste(){
        setMenuIsOpen( false )
        setAboutMeOptions(false)
    }

    let renderOptions;

    if(mouseOver === true){
        renderOptions = (
            <Zoom>
                <div id="options" onMouseLeave={handleMouseOver}>
                    <p><a href="#about-me">Sobre mim</a></p>
                    <p><a href="#what-i-do">O que eu faço?</a></p>
                    <p><a href="#my-education">Educação</a></p>
                </div>
            </Zoom>
        )
    }

    let renderLanguages;

    if(mouseOverLanguage === true){
        renderLanguages = (
            <Zoom>
                <div id="languages" onMouseLeave={handleMouseOverLanguages}>
                    <p onClick={setPortuguese}>Português</p>
                    <p onClick={setEnglish}>Inglês</p>
                </div>
            </Zoom>
        )
    }

    let renderMenu;

    if(menuIsOpen === true) {
        renderMenu = (
            <Fade top>
                <div id="menu">
                    <p><a href="#top" onClick={handleMenuIsOpen}>Home</a></p>
                    <p onClick={handleLanguageOptions}>Idioma</p>
                    <p onClick={handleAboutMeOptions}>Quem sou eu</p>
                    <p><a href="#my-projects" onClick={handleMenuIsOpen}>Projetos</a></p>
                    <p><a href="#contact-me" onClick={handleMenuIsOpen}>Contato</a></p>
                    <HighlightOffIcon className="clone-icon" onClick={handleMenuIsOpen}/>
                </div>
            </Fade>
        )
    }

    let renderAboutmeOptions;

    if(aboutMeOptions === true){
        renderAboutmeOptions = (
            <Fade top>
                <div id="about-me-options">
                    <p><a href="#about-me" onClick={teste}>Sobre mim</a></p>
                    <p><a href="#what-i-do" onClick={teste}>O que eu faço?</a></p>
                    <p><a href="#my-education" onClick={teste}>Educação</a></p>
                    <HighlightOffIcon className="clone-icon" onClick={handleAboutMeOptions}/>
                </div>
            </Fade>
        )
    }

    let renderLanguageOptions;

    if(languageOptions === true){
        renderLanguageOptions = (
            <Fade top>
                <div id="language-options">
                    <p onClick={setPortuguese}>Português</p>
                    <p onClick={setEnglish}>Inglês</p>
                    <HighlightOffIcon className="clone-icon" onClick={handleLanguageOptions}/>
                </div>
            </Fade>
        )
    }

    return(
        <header id="#top">
            <div className="desktop-header">
                <Fade left>
                    <p>Brian Mello</p>
                </Fade>
                <Fade right>
                    <nav>
                        {renderOptions}
                        {renderLanguages}
                        <p><a href="#top">Home</a></p>
                        <p onMouseEnter={handleMouseOverLanguages}>Idioma</p>
                        <p><a onMouseEnter={handleMouseOver} href="#about-me">Quem sou eu</a></p>
                        <p><a href="#my-projects">Projetos</a></p>
                        <p><a href="#contact-me">Contato</a></p>
                    </nav>
                </Fade>
            </div>
            <div className="mobile-header">
                <Fade left>
                    <p>Brian Mello</p>
                </Fade>
                <Fade right>
                    <MenuIcon className="menu-icon" onClick={handleMenuIsOpen}/>
                </Fade>
                {renderMenu}
                {renderAboutmeOptions}
                {renderLanguageOptions}
            </div>
        </header>
    )
}

export default Header;